<template>
    <div class="m-panel">
        <div class="m-panel-bar">
            <div class="m-panel-bar-title">
                {{title}}
            </div>
        </div>
        <div class="m-panel-body">
          <div class="fixed">
            <div class="header-order">{{ $t('序号') }}</div>
            <div class="header-item">{{ $t('工单类型') }}</div>
            <div class="header-item">{{ $t('工单紧急程度') }}</div>
            <div class="header-item">{{ $t('工单联系人') }}</div>
            <div class="header-item">{{ $t('联系电话') }}</div>
            <div class="header-item">{{ $t('申请人') }}</div>
            <div class="header-item">{{ $t('申请时间') }}</div>
            <div class="header-item">{{ $t('来源') }}</div>
            <div class="header-item">{{ $t('工单状态') }}</div>
          </div>
          <div style="overflow: hidden;height: calc(100% - 30px);">
            <vue-seamless-scroll :data="list" class="seamless-warp" ref="seamlessScroll" :class-option="classOption" @ScrollEnd="ScrollEnd">
              <ul class="list-ul">
                <li class="list-row" v-for="(item, index) in list" :key="index">
                  <div class="list-order">
                    <div class="order">{{ index + 1 }}</div>
                  </div>
                  <div class="list-item">{{ item.ticketsType == 0?$t('换表'):item.ticketsType == 1?$t('工程报装'):item.ticketsType == 2?$t('故障报修'):'-'}}</div>
                  <div class="list-item" :style="{color:item.ticketsEmergency == 0?'greenyellow':'red'}">{{ item.ticketsEmergency == 0?$t('正常'):item.ticketsType == 1?$t('紧急'):'-'}}</div>
                  <div class="list-item">{{ item.ticketsContact }}</div>
                  <div class="list-item">{{ item.ticketsContactPhone }}</div>
                  <div class="list-item">{{ item.createBy }}</div>
                  <div class="list-item">{{ setTime(item.createTime) }}</div>
                  <div class="list-item">{{ item.sourceType == 0?'PC':item.sourceType == 1?$t('小程序'):$t('公众号') }}</div>
                  <div class="list-item">
                    <div v-if="item.ticketsType == 0">
                      <div v-if="item.ticketsState == -1" class="state0">
                        {{ $t('已结束') }}
                      </div>
                      <div v-else :class="'state'+item.ticketsState">
                        {{$t(['未开启','换表登记','旧表审核','绑定新表','安装','审核工单'][item.ticketsState])}}
                      </div>
                    </div>
                    <div v-if="item.ticketsType == 1">
                      <div v-if="item.ticketsState == -1" class="state0">
                        {{ $t('已结束') }}
                      </div>
                      <div v-else :class="'state'+item.ticketsState">
                        {{$t(['未开启','报装申请','报装受理','报装勘察设计','报装预算','报装审批','报装收费','报装施工','报装验收','报装建档'][item.ticketsState])}}
                      </div>
                    </div>
                    <div v-if="item.ticketsType == 2">
                      <div v-if="item.ticketsState == -1" class="state0">
                        {{ $t('已结束') }}
                      </div>
                      <div v-else :class="'state'+item.ticketsState">
                        {{$t(['','未开启','接单','处理','归档'][item.ticketsState])}}
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </vue-seamless-scroll>
          </div>
        </div>
    </div>
</template>
<script>
import { getAction } from '@/api/manage'
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  components: {
      vueSeamlessScroll
  },
    data() {
        return{
            title: this.$t('实时数据'),
            url:{
              list: "/jeecg-engineering/ticket/tickets/list",
            },
            pageNo: 1,
            pageSize: -10,
            errorNum: 0,
            list:[],
        }
    },
    computed: {
      goOn() {
        return this.errorNum < 5;
      },
      classOption() {
        return {
          step: 0.5, // 数值越大速度滚动越快
          limitMoveNum: this.list.length, // 开始无缝滚动的数据量 this.dataList.length
          hoverStop: true, // 是否开启鼠标悬停stop
          direction: 1, // 0向下 1向上 2向左 3向右
          openWatch: true, // 开启数据实时监控刷新dom
          singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
          singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
          waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
        };
      },
    },
    mounted() {},
    methods: {
      ScrollEnd() {
      //   if(this.goOn) {
      //     this.getData()
      //   }
      },
      init() {
        this.resetData();
        this.getData();
      },
      resetData() {
          this.list = this.$options.data.call(this).list
      },
      getData(){
        this.list = [];
        getAction(this.url.list,{workState:0,pageSize:15}).then(res=>{
          if(res.success){
            this.list = res.result.records;
            this.$refs.seamlessScroll.reset()
          }
        })
      },
      setTime(time){
        if(time){
          var date = time.split(' ');
          var month = date[0].split('-')[1]+'-'+date[0].split('-')[2];
          var hM = date[1].split(':')[0]+':'+date[1].split(':')[1];
          return month+' '+hM;
        }else{
          return '-';
        }
      }
    },
}
</script>
<style lang="less" scoped>
  .fixed {
    display: flex;
    align-items: center;
    // justify-content: space-around;
    background-color: #08306F;
    // margin: 10px 3px;
    // padding: 0 10px;
    color: #FFF;
    height: 30px;
  
    .header-item {
      width: 28.33%;
      text-align: center;
    }
  
    .header-order {
      width: 15%;
      text-align: center;
    }
  }
  
  .plant-bg {
    height: calc(100% - 40px);
    overflow: hidden;
    // background: url(../../../assets/img/plant5.png) center center no-repeat;
    // background-size: 100% 100%;
  }
  
  .list-ul {
    /* width: 100%;
      background: #f67;
      display: flex;
      justify-content: space-between; */
  }
  
  .list-row {
    // margin: 0 20px;
    color: #b6deff;
    display: flex;
    height: 33px;
    align-items: center;
    line-height: 35px;
    border: 1px solid #011a3a;
    // background: url(../../../assets/img/list-bg.png) center no-repeat;
    // background-size: 100% 100%;
  
    .order {
      // background: #0989ff;
      width: 48px;
      height: 18px;
      // border: 2px solid #0759a5;
      border-radius: 2px;
      text-align: center;
      line-height: 18px;
      color: #fff;
    }
  }
  
  .list-row .list-item {
    width: 28.33%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    color: #fff;
  }
  
  .list-order {
    width: 15%;
    display: flex;
    justify-content: center;
  }
  
  .fill-cicle {
    height: 10px;
    width: 10px;
    border-radius: 10px;
    box-shadow: 0 0 5px 5px rgba(255, 0, 0, 0.5);
  }
  
  ul {
    padding-inline-start: 0;
  }
  
  .seamless-warp {
    height: 100%;
  }
  
  .seamless-warp:hover {
    overflow-y: scroll;
  }
  
  .seamless-warp::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  
  .seamless-warp::-webkit-scrollbar-track {
    background: #0e0c4f;
    border-radius: 2px;
  }
  
  .seamless-warp::-webkit-scrollbar-thumb {
    background: #292f88;
    border-radius: 2px;
  }
  
  .seamless-warp::-webkit-scrollbar-corner {
    background: #0e0c4f;
  }
  .state0{
    color: #f5f5f5;
  }
  .state1{
    color: #4634FA;
  }
  .state2{
    color: #F6BB2F;
  }
  .state3{
    color: #50E3C2;
  }
  .state4{
    color: #32C5FF;
  }
  .state5{
    color: #0091FF;
  }
  .state6{
    color: #0394FF;
  }
  .state7{
    color: #0C2D82;
  }
  .state8{
    color: #B620E0;
  }
  .state9{
    color: #F7B500;
  }
  .state10{
    color: #FA6400;
  }
  .state11{
    color: #E02020;
  }
</style>